/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchResponse } from '../../models/search-response';

export interface SearchByTypeV2$Params {
  search: string;
  offset: number;
  limit: number;
  searchBy: 'PROFILE' | 'ACTIVITY' | 'PROFILE_ACTIVITY';
}

export function searchByTypeV2(http: HttpClient, rootUrl: string, params: SearchByTypeV2$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchByTypeV2.PATH, 'get');
  if (params) {
    rb.path('search', params.search, {});
    rb.path('offset', params.offset, {});
    rb.path('limit', params.limit, {});
    rb.path('searchBy', params.searchBy, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchResponse>;
    })
  );
}

searchByTypeV2.PATH = '/rest/search-v2/{search}/{offset}/{limit}/{searchBy}';
